import type { ArticleCategory as Category } from '../../@types/ArticleCategory';
import type { ArticleCategory } from '../../@types/ArticleV2';
import { ARTICLES_QUERY_HITS } from '../../Data/Article/QueryKeys';
import { resolveArticlesRoute } from '../utils';

export const createArticleUrl = (categories: ArticleCategory[], slug: string) =>
  `/${resolveArticlesRoute()}/${categories[0].slug}/${slug}`;

const getCategoryQueryFromName = (category: string) => {
  return `categories=${encodeURIComponent(category)}`;
};

export const getArticlesURLSearchParams = (
  currentCategory: Category | undefined,
  search?: string,
) => {
  const params = new URLSearchParams(search);
  if (currentCategory) {
    const p = encodeURIComponent(
      new URLSearchParams(getCategoryQueryFromName(currentCategory.name)).get('categories') || '',
    );
    params.append('categories', p);
  }

  if (!params.has('hits')) {
    params.append('hits', `${ARTICLES_QUERY_HITS}`);
  }

  const page = params.get('page');
  if (page) {
    const pageAsNumber = Number.parseInt(page, 10);
    params.delete('page');
    params.set('offset', `${(pageAsNumber - 1) * ARTICLES_QUERY_HITS}`);
  }

  params.sort();

  return params;
};

export const getCategory = (categories: Category[] | undefined, pathname?: string) => {
  if (categories && pathname) {
    const splitted = pathname.split('/');
    if (splitted && splitted.length >= 3) {
      const category = splitted[2].split('?')[0];
      return categories.find((c) => c.slug === category);
    }
  }
  return undefined;
};
